import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useRef } from "react";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
// import FeaturesSection from "./components/FeaturesSection";
import CourseOffering from "./components/CourseOffering";
import PathwaySection from "./components/PathwaySection";
import CommitmentSection from "./components/CommitmentSection";
import Footer from "./components/Footer";
import FixedLogo from './components/FixedLogo';
import Images from "./components/Images.js";
import AboutUs from "./components/AboutUs";
import Maham from "./components/Maham";
import Toranj from "./components/Toranj";
import Hayk from "./components/Hayk";
import Faculty from "./components/Faculty";
import BlogDetails from "./components/Pages/Blog1.js";
import Talal from "./components/Talal";
import Maheshi from "./components/Maheshi";
import SignUp from "./components/SignUp";
import Login from "./components/Login";
import VideoGrid from "./components/VideoGrid";
import AdminDashboard from "./components/Dashboard/AdminDashboard";
import StudentDashboard from "./components/Dashboard/StudentDashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import ManageCourses from "./components/Dashboard/ManageCourses";
import IMATTestBreakdown from "./components/Pages/IMATTestBreakdown";
import GlobalTestCentres from "./components/Pages/GlobalTestCentres";
import ScholarshipOpportunities from "./components/Pages/ScholarshipOpportunities";
import VisionPage from "./components/Pages/VisionPage";
import UniversitiesPage from "./components/Pages/UniversitiesPage";
import UniversitiesPageDent from "./components/Pages/UniversitiesPageDent";
import UniversitiesSch from "./components/Pages/UniversitiesSch";
import UniversityPage from "./components/UniversityPage";
import UniversityPage2 from "./components/UniversityPage2";
import UniversityPage3 from "./components/UniversityPage3";
import UniversityPage4 from "./components/UniversityPage4";
import UniversityPage5 from "./components/UniversityPage5";
import UniversityPage6 from "./components/UniversityPage6";
import UniversityPage7 from "./components/UniversityPage7";
import UniversityPage8 from "./components/UniversityPage8";
import UniversityPage9 from "./components/UniversityPage9";
import UniversityPage10 from "./components/UniversityPage10";
import UniversityPage11 from "./components/UniversityPage11";
import Blog1 from "./components/Pages/Blog1";
import Blogs from "./components/Pages/Blogs";
import Blog2 from "./components/Pages/Blog2";
import Blog3 from "./components/Pages/Blog3";
import NotFoundPage from "./components/NotFoundPage";
import CourseDetailPage from "./components/Pages/CourseDetailPage";
import IMATMeditaliaPlus from "./components/Pages/IMATMeditaliaPlus";
import IMATMeditaliaPremium from "./components/Pages/IMATMeditaliaPremium";
import PdfViewer  from "./components/Pages/PdfViewer";
import Testimonials  from "./components/Pages/Testimonials";
import ImatCourse from './components/ImatCourse'; // Import the ImatCourse component
// Create this component for the IMAT course page

const App = () => {
    const courseSectionRef = useRef(null);
    const footerSectionRef = useRef(null);
    const aboutSectionRef = useRef(null);

    const scrollToSection = (ref) => (e) => {
        e.preventDefault();
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <Router>
            <Navbar 
                scrollToCourses={scrollToSection(courseSectionRef)} 
                scrollToFooter={scrollToSection(footerSectionRef)} 
                scrollToAbout={scrollToSection(aboutSectionRef)} 
            />
            <Routes>
                <Route
                    path="/"
                    element={
                        <>
                            <HeroSection />
                            {/* <FeaturesSection /> */}
                            <div ref={courseSectionRef}>
                                <CourseOffering />
                            </div>
                            <PathwaySection />
                            <CommitmentSection />
                           
                            <div ref={aboutSectionRef}>
                                <Images />
                            </div>
                           
                        </>
                    }
                />
                <Route path="/imat-test-breakdown" element={<IMATTestBreakdown />} />
                <Route path="/global-test-centres" element={<GlobalTestCentres />} />
                <Route path="/scholarship-opportunities" element={<ScholarshipOpportunities />} />
                <Route path="/vision-page" element={<VisionPage />} />
                <Route path="/universities-page" element={<UniversitiesPage />} />
                <Route path="/universities-page-dent" element={<UniversitiesPageDent />} />
                <Route path="/universities-sch" element={<UniversitiesSch />} />
                <Route path="/university-page" element={<UniversityPage />} />
                <Route path="/university-page2" element={<UniversityPage2 />} />
                <Route path="/university-page3" element={<UniversityPage3 />} />
                <Route path="/university-page4" element={<UniversityPage4 />} />
                <Route path="/university-page5" element={<UniversityPage5 />} />
                <Route path="/university-page6" element={<UniversityPage6 />} />
                <Route path="/university-page7" element={<UniversityPage7 />} />
                <Route path="/university-page8" element={<UniversityPage8 />} />
                <Route path="/university-page9" element={<UniversityPage9 />} />
                <Route path="/university-page10" element={<UniversityPage10 />} />
                <Route path="/university-page11" element={<UniversityPage11 />} />
                <Route path="/blogs" element={<Blog1 />} />
                <Route path="/blogs-all" element={<Blogs />} />
                <Route path="/blogss" element={<Blog2 />} />
                <Route path="/blogsss" element={<Blog3 />} />
                <Route path="/imat-course" element={<ImatCourse />} />
                <Route path="/CourseOffering" element={<CourseOffering />} />
                <Route path="/aboutus" element={<AboutUs />} />
                <Route path="/talal" element={<Talal />} />
                <Route path="/maheshi" element={<Maheshi />} />
                <Route path="/faculty" element={<Faculty />} />
                <Route path="/Toranj" element={<Toranj />} />
                <Route path="/Maham" element={<Maham />} />
                <Route path="/Hayk" element={<Hayk />} />
                <Route path="/blog/:blogId" element={<BlogDetails />} />
                <Route path="/about" element={<h1>About Us</h1>} />
                <Route path="/courses" element={<h1>Courses</h1>} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/login" element={<Login />} />
                <Route path="/VideoGrid" element={<VideoGrid />} />
                <Route path="/admin-dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
                <Route path="/student-dashboard" element={<ProtectedRoute><StudentDashboard /></ProtectedRoute>} />
                <Route path="/admin-dashboard/manage-courses" element={<ProtectedRoute><ManageCourses /></ProtectedRoute>} />
                <Route path="/course-detail" element={<CourseDetailPage />} />
                <Route path="/imat-meditalia-plus" element={<IMATMeditaliaPlus />} />
                <Route path="/course-detail2" element={<IMATMeditaliaPremium />} />
                <Route path="/papers" element={<PdfViewer  />} />
                <Route path="/testimonials" element={<Testimonials  />} />
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
            <FixedLogo/>

            <div ref={footerSectionRef}>
                                <Footer />
                            </div>
        </Router>
    );
};

export default App;